import { render, staticRenderFns } from "./UserAnswer.vue?vue&type=template&id=e7fd3834"
import script from "./UserAnswer.vue?vue&type=script&lang=js"
export * from "./UserAnswer.vue?vue&type=script&lang=js"
import style0 from "./UserAnswer.vue?vue&type=style&index=0&id=e7fd3834&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports